import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import toastr from 'toastr';
import getUtilsService from '~/services/utilsService';
import template from '~/templates/chartsFlutter.handlebars';
import GeneralView from '~/generalView';

var chartsFlutterView = GeneralView.View.extend({
	tagName: "div",
	className: '',

	render: function () {
		this.attachEvents();
		return this;
	},

	attachEvents: function() {		
        var permissions = getUtilsService.getprofilepermissions();

		var handlebarsTemplate = Handlebars.template(template);
		this.$el.html(handlebarsTemplate({permissions: permissions}));
	},
});
export default chartsFlutterView;
